! function ( t, n, e ) {
	t.fn.responsiveSlides = function ( a ) {
		var s = t.extend( {
			auto: !0,
			speed: 500,
			timeout: 4e3,
			pager: !1,
			nav: !1,
			random: !1,
			pause: !1,
			pauseControls: !0,
			prevText: "Previous",
			nextText: "Next",
			maxwidth: "",
			navContainer: "",
			manualControls: "",
			namespace: "rslides",
			before: t.noop,
			after: t.noop
		}, a );
		return this.each( function () {
			e++;
			var o, i, r, l, u, c, f = t( this ),
				d = 0,
				p = f.children(),
				h = p.length,
				v = parseFloat( s.speed ),
				m = parseFloat( s.timeout ),
				C = parseFloat( s.maxwidth ),
				x = s.namespace,
				b = x + e,
				y = x + "_nav " + b + "_nav",
				g = x + "_here",
				w = b + "_on",
				_ = b + "_s",
				I = t( "<ul class='" + x + "_tabs " + b + "_tabs' />" ),
				q = {
					float: "left",
					position: "relative",
					opacity: 1,
					zIndex: 2
				},
				z = {
					float: "none",
					position: "absolute",
					opacity: 0,
					zIndex: 1
				},
				T = function () {
					var t = ( document.body || document.documentElement ).style;
					if ( "string" == typeof t[ e = "transition" ] ) return !0;
					o = [ "Moz", "Webkit", "Khtml", "O", "ms" ];
					var n, e = e.charAt( 0 ).toUpperCase() + e.substr( 1 );
					for ( n = 0; n < o.length; n++ )
						if ( "string" == typeof t[ o[ n ] + e ] ) return !0;
					return !1
				}(),
				k = function ( n ) {
					s.before( n ), T ? ( p.removeClass( w ).css( z ).eq( n ).addClass( w ).css( q ), d = n, setTimeout( function () {
						s.after( n )
					}, v ) ) : p.stop().fadeOut( v, function () {
						t( this ).removeClass( w ).css( z ).css( "opacity", 1 )
					} ).eq( n ).fadeIn( v, function () {
						t( this ).addClass( w ).css( q ), s.after( n ), d = n
					} )
				};
			if ( s.random && ( p.sort( function () {
					return Math.round( Math.random() ) - .5
				} ), f.empty().append( p ) ), p.each( function ( t ) {
					this.id = _ + t
				} ), f.addClass( x + " " + b ), a && a.maxwidth && f.css( "max-width", C ), p.hide().css( z ).eq( 0 ).addClass( w ).css( q ).show(), T && p.show().css( {
					"-webkit-transition": "opacity " + v + "ms ease-in-out",
					"-moz-transition": "opacity " + v + "ms ease-in-out",
					"-o-transition": "opacity " + v + "ms ease-in-out",
					transition: "opacity " + v + "ms ease-in-out"
				} ), 1 < p.length ) {
				if ( m < v + 100 ) return;
				if ( s.pager && !s.manualControls ) {
					var F = [];
					p.each( function ( t ) {
						F += "<li><a href='#' class='" + _ + ( t += 1 ) + "'>" + t + "</a></li>"
					} ), I.append( F ), a.navContainer ? t( s.navContainer ).append( I ) : f.after( I )
				}
				if ( s.manualControls && ( I = t( s.manualControls ) ).addClass( x + "_tabs " + b + "_tabs" ), ( s.pager || s.manualControls ) && I.find( "li" ).each( function ( n ) {
						t( this ).addClass( _ + ( n + 1 ) )
					} ), ( s.pager || s.manualControls ) && ( c = I.find( "a" ), i = function ( t ) {
						c.closest( "li" ).removeClass( g ).eq( t ).addClass( g )
					} ), s.auto && ( r = function () {
						u = setInterval( function () {
							p.stop( !0, !0 );
							var t = d + 1 < h ? d + 1 : 0;
							( s.pager || s.manualControls ) && i( t ), k( t )
						}, m )
					} )(), l = function () {
						s.auto && ( clearInterval( u ), r() )
					}, s.pause && f.hover( function () {
						clearInterval( u )
					}, function () {
						l()
					} ), ( s.pager || s.manualControls ) && ( c.bind( "click", function ( n ) {
						n.preventDefault(), s.pauseControls || l(), n = c.index( this ), d === n || t( "." + w ).queue( "fx" ).length || ( i( n ), k( n ) )
					} ).eq( 0 ).closest( "li" ).addClass( g ), s.pauseControls && c.hover( function () {
						clearInterval( u )
					}, function () {
						l()
					} ) ), s.nav ) {
					x = "<a href='#' class='" + y + " prev'>" + s.prevText + "</a><a href='#' class='" + y + " next'>" + s.nextText + "</a>", a.navContainer ? t( s.navContainer ).append( x ) : f.after( x );
					var M = ( b = t( "." + b + "_nav" ) ).filter( ".prev" );
					b.bind( "click", function ( n ) {
						if ( n.preventDefault(), !( n = t( "." + w ) ).queue( "fx" ).length ) {
							var e = p.index( n );
							n = e - 1, e = e + 1 < h ? d + 1 : 0, k( t( this )[ 0 ] === M[ 0 ] ? n : e ), ( s.pager || s.manualControls ) && i( t( this )[ 0 ] === M[ 0 ] ? n : e ), s.pauseControls || l()
						}
					} ), s.pauseControls && b.hover( function () {
						clearInterval( u )
					}, function () {
						l()
					} )
				}
			}
			if ( void 0 === document.body.style.maxWidth && a.maxwidth ) {
				var D = function () {
					f.css( "width", "100%" ), f.width() > C && f.css( "width", C )
				};
				D(), t( n ).bind( "resize", function () {
					D()
				} )
			}
		} )
	}
}( jQuery, this, 0 );
